import { Box, Card, CardContent, Paper, Stack, Theme, Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";
import UpcomingConversationsComponent from "./UpcomingConversationsComponent";
import OngoingAppointmentsComponent from "./OngoingAppointmentsComponent";
import { LanguageContext } from "../context/LanguageContext";
import { useContext } from "react";

const AnnualInterviewsComponent = () => {
  const { strings } = useContext(LanguageContext);
  return (
    <Card sx={{ height: "100%" }}>
      <CardContent
        sx={{
          px: 0,
          height: "100%",
          display: "grid",
          gridTemplateRows: "auto 1fr",
        }}
      >
        <Box mb={2}>
          <Stack
            direction={"row"}
            sx={{
              alignItems: "flex-start",
              justifyContent: "space-between",
            }}
          >
            <Typography variant="h3" component="h3">
              {strings.interviews.title}
            </Typography>
          </Stack>
        </Box>
        <Grid container spacing={2} sx={{ height: "100%" }}>
          <Grid size={4}>
            <Paper
              sx={(theme: Theme) => ({
                boxShadow: "unset",
                borderRadius: 0,
                bgcolor: theme.palette.light.main,
                p: 2,
                height: "100%",
              })}
            >
              <UpcomingConversationsComponent />
            </Paper>
          </Grid>
          <Grid size={8}>
            <Paper
              sx={(theme: Theme) => ({
                boxShadow: "unset",
                borderRadius: 0,
                bgcolor: theme.palette.light.main,
                p: 2,
                height: "100%",
              })}
            >
              <OngoingAppointmentsComponent />
            </Paper>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default AnnualInterviewsComponent;
